import {createLoaderWorker} from '@loaders.gl/loader-utils';
import {LASLoader} from '../index';

createLoaderWorker(LASLoader);
